import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import IranSans from "./Assets/Fonts/irsans.ttf"
import { } from '@mui/material/colors';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';


// handle Rtl
// export const cacheRtl = createCache({
//     key: 'muirtl',
//     stylisPlugins: [prefixer, rtlPlugin],
// });

export let CustomTheme = createTheme({
    palette: {
        primary: {
            main: "#006308"
        },
        secondary: {
            main: "#39b54a"
        },
        teritiary: {
            main: "#19176E"
        },
        text: {
            primary: "#333333",
            secondary: "#434343"
        },
        background: {
            main: "#FFF"
        }
    },
    transitions: {
        duration: "0.4s"
    },
    typography: {
        fontFamily: "A Iranian Sans, sans-serif",
        h2: {
            fontSize: "32px"
        },
        h3: {
            fontSize: "18px",
            fontWeight: "bold"
        },
        h4: {
            fontSize: "18px",
            fontWeight: "bold"
        },
        body1: {
            fonSize: "12px",
            fontWeight: "normal", 
        },
        button: {
            fontSize: "14px",
        },
        tableHeads: {
            fontSize: "12px",
            fontWeight: "bold",
            fontFamily: "Roboto"
            
        },
        caption: {
            fontSize: "12px"
        }
    },
    // spacing: "8px",
    components: {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    "& fieldset" : {
                        border: "none !important",
                        boxShadow: "0 2px 8px 1px rgba(64,60,67,.24) !important"
                    },
                    "& .MuiInputBase-root" : {
                        padding: "4px"
                    },
                }
            }
        }
    }
});

CustomTheme = responsiveFontSizes(CustomTheme)